import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Link, Typography } from "@mui/material";
import {
  CashAccountsCard,
  InvestmentsCard,
  useBankSelectModal,
} from "@components";
import { useDashboardSelectedGroupsContext } from "@features/dashboard/DashboardSelectedGroupProvider.tsx";
import { useBankImportReturnUrl } from "@hooks/useBankImportReturnUrl";

const AssetsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;

const AssetsHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const AssetsHeader = styled(Typography)`
  margin: ${({ theme }) => theme.spacing(6, 0, 4)};
`;

interface AssetsProps {
  investmentsCount: number;
  cashAccountsBalance: number;
}

export const Assets = (props: AssetsProps) => {
  const { investmentsCount, cashAccountsBalance } = props;
  const { groupedAccountIds, isFetching } = useDashboardSelectedGroupsContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { saveReturnUrl } = useBankImportReturnUrl();
  const { openBankSelect, bankSelectModal } = useBankSelectModal();

  return (
    <div>
      <AssetsHeaderWrapper>
        <AssetsHeader variant="body3" color="textSecondary" fontWeight={600}>
          {t("dashboardPage.allYourAssets")}
        </AssetsHeader>
        <Link onClick={() => navigate("/investments")} underline="hover">
          <Typography variant="body3">
            {t("dashboardPage.investmentsLink")}
          </Typography>
        </Link>
      </AssetsHeaderWrapper>

      <AssetsWrapper>
        <InvestmentsCard
          investmentsCount={investmentsCount}
          onAddAccountsClick={() => {
            saveReturnUrl();
            openBankSelect();
          }}
          onClick={() => {
            navigate("/investments");
          }}
        />
        <CashAccountsCard
          areAccountsLoading={isFetching}
          cashAccountsIds={groupedAccountIds.cashIds}
          balance={cashAccountsBalance}
          onAddAccountsClick={() => {
            saveReturnUrl();
            openBankSelect();
          }}
          onClick={() => {
            navigate("/accounts");
          }}
        />
      </AssetsWrapper>
      {bankSelectModal}
    </div>
  );
};
